export const roleTableColumns = [
  {
    label: "角色名称",
    value: "name"
  },
  {
    label: "角色描述",
    value: "description"
  },
  {
    label: "人数",
    value: "count"
  }
]

export const userTableColumns = [
  {
    label: "姓名",
    value: "name"
  },
  {
    label: "手机号",
    value: "telephone"
  }
]

export const reviewColumns = [
  {
    label: "姓名",
    value: "user.name"
  },
  {
    label: "状态",
    value: "status"
  },
  {
    label: "手机号",
    value: "user.telephone"
  },
  {
    label: "审核人",
    value: "verifier.name"
  },
  {
    label: "申请时间",
    value: "createAt"
  },
  {
    label: "审核时间",
    value: "updateAt"
  }
]

export const authorityList = [
  {
    label: "企业管理",
    value: "company-manage",
    children: [
      {
        label: "企业信息",
        value: "company-manage-info"
      },
      {
        label: "企业日历",
        value: "company-manage-calendar"
      }
    ]
  },
  {
    label: "组织架构",
    value: "company-structure",
    children: [
      {
        label: "企业成员",
        value: "company-user"
      },
      {
        label: "企业角色",
        value: "company-role"
      },
      {
        label: "邀请审核",
        value: "invite-review"
      }
    ]
  },
  {
    label: "数据安全",
    value: "company-data-security",
    children: [
      {
        label: "管理日志",
        value: "company-manage-log"
      }
    ]
  },
  {
    label: "系统对接",
    value: "company-system",
    children: [
      {
        label: "系统对接",
        value: "company-system-joint"
      }
    ]
  },
  {
    label: "应用管理",
    value: "manage-app",
    children: [
      {
        label: "应用列表",
        value: "apps"
      },
      {
        label: "应用列表(我管理的)",
        value: "managed-app"
      },
      {
        label: "应用模板",
        value: "app-template"
      },
      {
        label: "应用模板(我创建的)",
        value: "created-app-template"
      },
      {
        label: "应用分组",
        value: "app-group"
      }
    ]
  },
  {
    label: "项目管理",
    value: "manage-project",
    children: [
      {
        label: "项目列表",
        value: "projects"
      },
      {
        label: "项目列表(我管理的)",
        value: "managed-project"
      },
      {
        label: "项目模板",
        value: "project-template"
      },
      {
        label: "项目模板(我创建的)",
        value: "created-project-template"
      },
      {
        label: "项目分组",
        value: "project-group"
      },
      {
        label: "任务模板",
        value: "company-manage-task-template"
      }
    ]
  },
  {
    label: "互联管理",
    value: "manage-connect",
    children: [
      {
        label: "互联企业",
        value: "company-manage-connect-list"
      },
      {
        label: "互联角色",
        value: "company-manage-connect-type"
      }
    ]
  }
]

export const specialMenus = [
  "应用列表(我管理的)",
  "应用模板(我创建的)",
  "项目列表(我管理的)",
  "项目模板(我创建的)"
]

export const searchableInfos = [
  {
    label: "姓名",
    value: "name"
  },
  {
    label: "状态",
    value: "status"
  },
  {
    label: "手机号",
    value: "telephone"
  }
]

export const stateOptions = [
  {
    label: "待审核",
    value: "待审核"
  },
  {
    label: "已通过",
    value: "已通过"
  },
  {
    label: "已拒绝",
    value: "已拒绝"
  }
]
